import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import useUserStore from "@/modules/users/store";
import { EMBAIXADORES_PESSOAS_COLLECTION_KEY, getEmbaixadoresPessoas } from "../firestore";

const useEmbaixadoresPessoas = () => {
  const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);

  return useQuery<TEmbaixadorPessoa[], FirestoreError>({
    queryKey: [...EMBAIXADORES_PESSOAS_COLLECTION_KEY, { empresaId: activeEmpresaId }],
    queryFn: async () => {
      if (!activeEmpresaId) {
        throw new Error("Empresa não selecionada");
      }
      const [snapshot] = await getEmbaixadoresPessoas(activeEmpresaId);
      return snapshot.docs.map((document_) => document_.data());
    },
    enabled: !!activeEmpresaId
  });
};

export default useEmbaixadoresPessoas;
